'use strict';

angular.module('schoolbushubApp')
    .factory('NotificationAudit', function ($resource, DateUtils) {
        return $resource('api/notificationAudits/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.date = DateUtils.convertDateTimeFromServer(data.date);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });
